import _get from "lodash/get";
import styled, { css } from 'styled-components';
import formTheme from '../../styles/formTheme';
var FormInputBar = styled.span.withConfig({
  displayName: "FormInputBar",
  componentId: "sc-18cjggu-0"
})(["display:block;position:relative;width:auto;:before,:after{background:", ";bottom:0;content:'';height:2px;position:absolute;transition:0.3s ease all;width:0;}:before{left:50%;}:after{right:50%;}", " ", ""], function (_ref) {
  var theme = _ref.theme,
      skin = _ref.skin;
  return _get(theme, "form.input." + skin + ".borderColorFocus", formTheme.form.input[skin].borderColorFocus);
}, function (_ref2) {
  var active = _ref2.active;
  return active && css([":before,:after{width:50%;}"]);
}, function (_ref3) {
  var error = _ref3.error,
      isSubmitted = _ref3.isSubmitted,
      theme = _ref3.theme;
  return (error || error && isSubmitted) && css([":before,:after{background:", ";width:50%;}"], _get(theme, 'form.error.color', formTheme.form.error.color));
});
export default FormInputBar;